import React, { useMemo } from "react";
import { useAppSelector } from "../../../redux/hook";
import { AlertInfo } from "../../common/Alert";
import BestSellerCatalogGrid from "../../HomePage/BestSellerCatalogGrid";
import { useFavoriteByUserQuery } from "../../../utils/api/favories/favorie.api";
import type { Favorie } from "../../../utils/api/favories/favorie.type";
import type { Product } from "../../../utils/api/product/product.type";

const FavorisPage = () => {
  const { user } = useAppSelector((s) => s?.user);

  const { data, isLoading, isError } = useFavoriteByUserQuery(
    user?.slug as string,
    { skip: !user?.slug }
  );

  const favorisRows: Favorie[] = useMemo(() => {
    if (data == null) return [];
    return Array.isArray(data) ? data : [data as unknown as Favorie];
  }, [data]);

  const products: Product[] = useMemo(
    () =>
      favorisRows
        .map((row) => row?.produit)
        .filter((p): p is Product => p != null && p.id != null),
    [favorisRows]
  );

  const showGrid = isLoading || (!isError && products.length > 0);

  return (
    <div className="form-register-tabs-component">
      {/* Même arbre DOM / classes que « NOS MEILLEURES VENTES » (doc YEKSINA §1.4 + §5) */}
      <section
        className="best-sellers-section best-sellers-section--account-favoris best-sellers-section--embedded px-lg-3"
        aria-labelledby="favoris-page-heading"
      >
        <div className="best-sellers-section-container">
          <header className="best-sellers-section-header">
            <h2
              id="favoris-page-heading"
              className="best-sellers-section-title text-center"
            >
              Mes favoris
            </h2>
          </header>

          {isError && (
            <AlertInfo message="Impossible de charger vos favoris pour le moment." />
          )}

          {!isError && !isLoading && products.length === 0 && (
            <AlertInfo message="Aucun produit disponible dans vos favoris !" />
          )}

          {showGrid && !isError && (
            <BestSellerCatalogGrid
              products={products}
              isLoading={isLoading}
              skeletonCount={4}
              visualContext="favorisPage"
            />
          )}
        </div>
      </section>
    </div>
  );
};

export default FavorisPage;
